'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import utils from 'services/utils';

import classNames from 'classnames';

import 'styles/Popover.scss';


const propTypes = {
    content: PropTypes.object,
    showBelow: PropTypes.bool,
    buttonOnly: PropTypes.bool,
    isInOverflowHidden: PropTypes.bool, //Required to force popover our of a overflow hidden element. GS
};

const defaultProps = {
};

let timeout;

class Popover extends React.Component {

    constructor(props) {
        super(props);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.state = {
            extraInfoVisible: false,
        };
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.hide);        
    }

    show(event) {
        utils.preventDefault(event);
        this.setState({
            extraInfoVisible: true,
        }, function () {
            if (this.refs.popover) {
                const popover = this.refs.popover;
                const popoverWrapper = popover.parentElement;
                const popoverMask = popover.querySelector('.popover-mask');
                const popoverArrow = popover.querySelector('.popover-arrow');
                
                const width = popoverMask.clientWidth;
                const height = popoverMask.clientHeight;
                const parentWidth = popover.parentElement.clientWidth;
                const parentHeight = popover.parentElement.clientHeight;
                
                popover.style.width = width  + "px";
                popover.style.height = height + 'px';

                const verticalPosition = (parentHeight + popoverArrow.clientHeight / 2) + 'px';
                let arrowOffset = 0 ;

                if (this.props.showBelow) {
                    popover.style.top = verticalPosition;
                } else {
                    popover.style.bottom = verticalPosition;
                    arrowOffset = popoverArrow.clientWidth / 2;
                }
                
                popover.style.left = (parentWidth - width) / 2  + "px";
                popoverArrow.style.left = (width / 2 - 10) + "px";

                const viewportOffset = popover.getBoundingClientRect();

                // if the popover is outside the left side of the viewport, then adjust so that it fits the viewport
                if (viewportOffset.left < 0) {
                    popover.style.left = parseFloat(popover.style.left) - viewportOffset.left + 10 + 'px';
                    popoverArrow.style.left = parseFloat(popoverArrow.style.left) + viewportOffset.left - arrowOffset + 'px';
                }                

                if (viewportOffset.right > window.innerWidth) {
                    const offset = viewportOffset.right - window.innerWidth + 30;
                    popover.style.left = parseFloat(popover.style.left) - offset + 'px';
                    popoverArrow.style.left = parseFloat(popoverArrow.style.left) + offset + 'px';
                }                
            }
            document.addEventListener("click", this.hide);
        });
    }

    hide(event) {
        utils.preventDefault(event); 
        event.stopPropagation();
        
        this.setState({
            extraInfoVisible: false,
        });
        document.removeEventListener("click", this.hide);
    }

    mouseEnter(event) {
        this.show(event);
    }

    mouseLeave(event) {
        this.hide(event);
    }

    render() {

        return (
            <div
                className={classNames('popover-wrapper', {'visible': this.state.extraInfoVisible, 'is-in-overflow-hidden': this.props.isInOverflowHidden})}
                onClick={!this.props.useHoverInsteadOfClick ? this.show.bind(this) : null}
                onMouseEnter={this.props.useHoverInsteadOfClick ? this.mouseEnter.bind(this) : null}
                onMouseLeave={this.props.useHoverInsteadOfClick ? this.mouseLeave.bind(this) : null}
            >
                <span className={classNames('popover-link', {'visible': this.state.extraInfoVisible, 'button--plain add-button': this.props.buttonOnly, 'use-hover-instead-of-click': this.props.useHoverInsteadOfClick})}>{this.props.children}</span>
                {this.props.content ? (
                    <div ref="popover" className={classNames('popover', {visible: this.state.extraInfoVisible})}>
                        <div className={classNames('popover-arrow',  {up: this.props.showBelow})}></div>
                        <div className="popover-mask">
                            {this.props.content}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
export default Popover;
